module.exports = __webpack_public_path__ + "static/media/footer-background-mountain.2925e299.png";